import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'palantir-content',
  templateUrl: './palantir-content.component.html',
  styleUrls: ['./palantir-content.component.scss'],
})
export class PalantirContentComponent {}
